import { useState, createContext } from "react";

const Context = createContext();

const Provider = ({ children }) => {
    const[states, setStates] = useState(null);
    const[countries, setCountries] = useState(null);
    const[nationalities, setNationalities] = useState(null);
    const[dependencies, setDependencies] = useState(null);
    const[marketRates, setMarketRates] = useState(null);
    const[basePath, setBasePath] = useState('##CONTEXTO##');
    // const [loading, setLoading] = useState(false);

    return (
        <Context.Provider value={{
            states,
            setStates,
            countries,
            setCountries,
            dependencies,
            nationalities,
            setNationalities,
            setDependencies,
            marketRates,
            setMarketRates,
            basePath,
            setBasePath,            
        }}>
            {children}
        </Context.Provider>
    )

}

export {Context,Provider}